import { Component, OnInit, Input, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
	selector: 'ras-video-banner',
	templateUrl: './video-banner.component.html',
	styleUrls: ['./video-banner.component.sass']
})
export class VideoBannerComponent implements OnInit {

	@Input() preview: string;
	@Input() set video(code: string) {
		if (code != this.video_code) {
			this.video_code = code;
			this.video_url = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + code);
		}
	}
	@Input() text: string;
	@Input() position: string = "center";

	public show_video = false;
	public video_code = "";
	public video_url: SafeResourceUrl | null = null;

	constructor(public sanitizer: DomSanitizer) { }

	ngOnInit(): void {
	}

}
